import React from 'react';
import { StyleSheet, View } from 'react-native';
import WrapBottomColor from '../../containers/WrapBottomColor';
import BottomButton from '../../BottomButton';
import { useActionSheet } from '@expo/react-native-action-sheet';
import { requestRide, getLatLng } from '../../../utils/directions.util';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Icon from '../../Icon';
import BaseText from '../../BaseText';
import { CommonStyles, Color } from '../../../styles';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../../i18n';

const RideShareModal = ({ route }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('RideShareModal');
  const { page } = route.params;
  const { showActionSheetWithOptions } = useActionSheet();

  let responseDetails;
  const address = [];
  if (page == 'car') {
    responseDetails = 'CarResponseDetails';
    address.push('PickupAddress');
    address.push('DropoffAddress');
  } else if (page == 'hotel') {
    responseDetails = 'HotelResponseDetails';
    address.push('AddressLine1');
  }
  const location = useSelector(
    (state) =>
      state.payment &&
      state.payment.receiptResponse &&
      state.payment.receiptResponse[responseDetails] &&
      state.payment.receiptResponse[responseDetails][0]
  );

  const RideOption = async () => {
    const latlng1 = await getLatLng(location[address[0]]);
    if (page == 'hotel') {
      return latlng1;
    }
    if (page == 'car') {
      const latlng2 = await getLatLng(location[address[1]]);
      if (moment().diff(moment(location.PickupDate), 'days') <= 0) {
        return latlng1;
      } else {
        return latlng2;
      }
    }
  };
  const onSubmit = () => {
    showActionSheetWithOptions(
      { options: ['Lyft', 'Uber', t(tKey('Cancel'))], cancelButtonIndex: 2 },
      async (buttonIndex) => {
        const dropoff = await RideOption();
        if (buttonIndex === 0) {
          requestRide('lyft', dropoff);
        } else if (buttonIndex === 1) {
          requestRide('uber', dropoff);
        }
      }
    );
  };
  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <Icon name="car" style={[CommonStyles.mb2, styles.icon]} size={75} color={Color.primary} />
        <BaseText style={styles.textBox}>
          {t(tKey('InordertouseLyftorUberTripeasywouldliketo'))}
        </BaseText>
        <BaseText style={styles.textBox}>{t(tKey('Currentlatitudelongitude'))}</BaseText>
      </View>
      <BottomButton label={t(tKey('Accept'))} full onPress={onSubmit} />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
  textBox: {
    textAlign: 'center',
    marginHorizontal: '20%',
  },
  icon: {
    alignSelf: 'center',
  },
});

export default RideShareModal;
